import { Translation } from '../foundation/Translation'
import { BlockContainer } from './BlockContainer'
import { ModuleContainer } from './ModuleContainer'

/**
 * Component for display an error to user
 */
export function ErrorComponent({ errorId = 'unknown' }: { errorId?: string }) {
	return <Translation as="p" id={`error:${errorId}`} />
}

/**
 * Component for display an error for an entire module
 */
export function ErrorModule({ errorId }: { errorId?: string }) {
	return (
		<ModuleContainer>
			<BlockContainer>
				<ErrorComponent errorId={errorId} />
			</BlockContainer>
		</ModuleContainer>
	)
}
